import React from 'react';

import {DropZone} from '@pb/kit-component-dropzone';
import {Group, Item} from '@pb/kit-component-group';
import {Icon, Icons, Sizes} from '@pb/kit-component-icon';
import Loading, {Types} from '@pb/kit-component-loading';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

import {fileAttachmentUpload, fileAttachmentUploadError} from './trigger-attachment.module.styl';

type Props = {
    isUploading: boolean,
    validationHighLight?: boolean,
    onUploadFiles: (acceptedFiles: File[]) => void,
};

const ERROR_AUTO_HIDE_TIMEOUT = 10000;
const MAX_FILE_SIZE_LIMIT = 1024 * 1024 * 25;
const ERROR_MESSAGE = 'Upload failed. Please select an image or video file under 25MB.';

export const AttachmentUpload = (props: Props) => {
    const {
        isUploading,
        validationHighLight,
        onUploadFiles,
    } = props;

    const {onCreateNote} = usePushNotification();

    const onDropRejected = async () => {
        await onCreateNote({
            id: 'dropzoneFailure',
            status: Status.ERROR,
            message: ERROR_MESSAGE,
            buttonProps: {iconProps: {type: Icons.CLOSE}},
            autoHideTimeout: ERROR_AUTO_HIDE_TIMEOUT,
        });
    };

    return (
        <Group direction="v" gap="xxs">
            <Item className={fileAttachmentUpload}>
                <DropZone
                    mix={validationHighLight ? fileAttachmentUploadError : ''}
                    accept="image/jpeg,image/png,video/*"
                    maxSize={MAX_FILE_SIZE_LIMIT}
                    onDropRejected={onDropRejected}
                    onDrop={onUploadFiles}
                    multiple={false}>
                    {isUploading ? (
                        <Group direction="v" alignItems="center">
                            <Loading fast={true} type={Types.ICON}/>
                            <Item>Uploading...</Item>
                        </Group>
                    ) : (
                        <Group direction="v" alignItems="center">
                            <Icon type={Icons.UPLOAD} size={Sizes.Size_16}/>
                            <Item>Add event trigger</Item>
                        </Group>
                    )}
                </DropZone>
            </Item>
            <Item>&nbsp;</Item>
        </Group>
    );
};
